module.exports = __webpack_public_path__ + "static/media/11.d4f72d23.svg";